import * as React from 'react';
import { connect } from 'react-redux';
import { getOrgUsers, getUserById, updateUser } from '~/apps/shared/actions/users';
import { getOrgLocations } from '~/apps/shared/actions/locations';
import UserUpdateFormOverlay from '../../components/users/UserUpdateFormOverlay';
import Loader from '~/common/components/Loader';


class UserEditPopup extends React.Component<any, any> {
  componentDidMount() {
    const { dispatch, orgId } = this.props;
    dispatch(getUserById(this.props.userId));
    dispatch(getOrgLocations(orgId));
  }

  onSubmit = (data) => {
    const { dispatch, userId, onReturn } = this.props;
    const req = {
      ...data,
      locationId: !data.locationId ? '' : data.locationId,
    };

    return dispatch(updateUser(userId, req))
      .then(() => {
        dispatch(getOrgUsers()).then(() => {
          onReturn();
        });
      });
  };

  onClose = () => {
    this.props.onReturn();
  };

  locationOptions = () => {
    const { locations: { entities, ui: { currentList } } } = this.props;

    return [{
      label: '- Without Location -',
      value: null,
    }].concat(currentList.map((id) => (
      {
        label: entities[id].name,
        value: id,
      }
    )))
  };


  render() {
    const { users, userId } = this.props;
    const user = users.entities[userId];
    const { loading, errorMessage } = users.ui;
    const userName = !user ? '' : user.username;

    if (loading) {
      return (
        <Loader className="load--ol" />
      );
    }

    return (
      <UserUpdateFormOverlay
        headTitle={`Edit User - ${userName}`}
        onSubmit={this.onSubmit}
        onClose={this.onClose}
        user={user}
        locations={this.locationOptions()}
        errorMessage={errorMessage}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.shared.users,
    locations: state.shared.locations,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserEditPopup) as any;
